import { AxiosPromise } from 'axios'
import {
  DataCDRDetailResponseType,
  DataCDRResponseType,
  DataCheckReponseType,
  EsimStatusType,
  ImsiType,
  RefreshNetworkType
} from 'types/api/faber/dataUsage.type'

import FaberApi from '.'

class DataApi {
  /**
   * To manually rollover user
   */
  static executeManualRollover({
    timeStamp: timeStamp,
    iccid: iccid,
    faberToken: faberToken
  }: {
    timeStamp: Date
    iccid: string
    faberToken: string
  }) {
    return FaberApi.httpPost(
      `/rolloverv2/manual_${timeStamp}_data_rollover_v2`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        rolloverDate: '',
        rolloverICCID: [iccid]
      }
    )
  }

  static getDataCDROverview(
    iccid: string,
    faberToken: string
  ): AxiosPromise<DataCDRResponseType> {
    return FaberApi.httpGet(
      `/cdr/package/group/${iccid}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getDataCDRDetailedRecords(
    iccid: string,
    faberToken: string
  ): AxiosPromise<DataCDRDetailResponseType> {
    return FaberApi.httpGet(
      `/cdr/package/detail/${iccid}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getUserDataCheck(
    iccid: string,
    faberToken: string
  ): AxiosPromise<DataCheckReponseType> {
    return FaberApi.httpGet(
      `/cdr/data-check/${iccid}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getImsiData(
    faberToken: string,
    ICCID: string
  ): AxiosPromise<ImsiType> {
    return FaberApi.httpGet(
      `/location/latest/${ICCID}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getEsimStatus(
    faberToken: string,
    userID: string
  ): AxiosPromise<EsimStatusType> {
    return FaberApi.httpPut(
      `/esim/status/${userID}`,
      { Authorization: `Bearer ${faberToken}` },
      true
    )
  }

  static refreshNetwork({
    userId: userId,
    iccid: iccid,
    faberToken: faberToken
  }: {
    userId: string
    iccid: string
    faberToken: string
  }): AxiosPromise<RefreshNetworkType> {
    return FaberApi.httpPost(
      `/sim/ops/esim/refresh/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        iccid: iccid
      }
    )
  }
}
export default DataApi
